import React from "react";
import {
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid,
  Typography
} from "@mui/material";

import moment from "moment";
import "moment/locale/pt";

import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TaskIcon from "@mui/icons-material/Task";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import ArticleIcon from "@mui/icons-material/Article";
import GavelIcon from "@mui/icons-material/Gavel";
import AutorenewIcon from "@mui/icons-material/Autorenew";

import FolderIcon from "@mui/icons-material/Folder";

const PRORROGACAO_CODIGOS = ['IPAS055', 'IPAS056', 'IPAS057', 'IPAS058', 'IPAS059'];

const ProcessDetailsHeader = ({
  data,
  data_concessao,
  data_deposito,
  data_vigencia,
  despachos,
  data_publicacao: data_publicacao_prop,
  data_deferimento: data_deferimento_prop,
  data_prorrogacao: data_prorrogacao_prop,
}) => {
  const data_publicacao = data_publicacao_prop ?? despachos?.find((d) => d.codigo === 'IPAS009')?.data ?? null;
  const data_deferimento = data_deferimento_prop ?? despachos?.find((d) => d.codigo === 'IPAS029')?.data ?? null;
  const data_prorrogacao = data_prorrogacao_prop ?? despachos?.find((d) => PRORROGACAO_CODIGOS.includes(d.codigo))?.data ?? null;
  return (
    <List>
      {data.length > 0
        ? data.map((info) => (
            <>
              <ListItem>
                <ListItemIcon>
                  <Avatar>{info.icon ? info.icon : <FolderIcon />}</Avatar>
                </ListItemIcon>
                <ListItemText
                  primary={info.title}
                  style={{
                    fontWeight: 800,
                  }}
                  secondary={info.subtitle ?? ""}
                />
              </ListItem>
              <Divider />
            </>
          ))
        : null}
      <ListItem>
        <Grid container width="100%" spacing={2} my={1}>
          <Grid item xs={6}>
            <Timeline position="right">
              <TimelineItem>
                <TimelineOppositeContent
                  sx={{ m: "auto 0" }}
                  align="right"
                  variant="body2"
                  color="text.secondary"
                >
                  {`${
                    data_deposito
                      ? "O processo foi depositado em " +
                        moment
                          .utc(data_deposito)
                          .format("DD/MM/YYYY") +
                        "."
                      : "Nenhuma data informada"
                  }`}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineConnector />
                  <TimelineDot
                    color={data_deposito ? "primary" : "grey"}
                  >
                    <TaskIcon />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: "12px", px: 2 }}>
                  <Typography variant="h6" component="span">
                    Data de depósito
                  </Typography>
                </TimelineContent>
              </TimelineItem>
              <TimelineItem>
                <TimelineOppositeContent
                  sx={{ m: "auto 0" }}
                  variant="body2"
                  color="text.secondary"
                >
                  {data_publicacao
                    ? "Publicado em " + moment.utc(data_publicacao).format("DD/MM/YYYY") + "."
                    : "Sem data de publicação."}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineConnector />
                  <TimelineDot color={data_publicacao ? "primary" : "grey"}>
                    <ArticleIcon />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: "12px", px: 2 }}>
                  <Typography variant="h6" component="span">
                    Data de publicação
                  </Typography>
                </TimelineContent>
              </TimelineItem>

              <TimelineItem>
                <TimelineOppositeContent
                  sx={{ m: "auto 0" }}
                  variant="body2"
                  color="text.secondary"
                >
                  {data_deferimento
                    ? "Deferido em " + moment.utc(data_deferimento).format("DD/MM/YYYY") + "."
                    : "Sem data de deferimento."}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineConnector />
                  <TimelineDot color={data_deferimento ? "success" : "grey"}>
                    <GavelIcon />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: "12px", px: 2 }}>
                  <Typography variant="h6" component="span">
                    Data de deferimento
                  </Typography>
                </TimelineContent>
              </TimelineItem>

              <TimelineItem>
                <TimelineOppositeContent
                  sx={{ m: "auto 0" }}
                  variant="body2"
                  color="text.secondary"
                >
                  {`${
                    data_concessao
                      ? "Concedido em " +
                        moment
                          .utc(data_concessao)
                          .format("DD/MM/YYYY") +
                        "."
                      : "Não concedido."
                  }`}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineConnector />
                  <TimelineDot
                    color={data_concessao ? "success" : "grey"}
                  >
                    <CheckCircleIcon />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: "12px", px: 2 }}>
                  <Typography variant="h6" component="span">
                    Data de concessão
                  </Typography>
                </TimelineContent>
              </TimelineItem>

              <TimelineItem>
                <TimelineOppositeContent
                  sx={{ m: "auto 0" }}
                  variant="body2"
                  color="text.secondary"
                >
                  {`${
                    data_vigencia
                      ? "A data de vigência é até " +
                        moment
                          .utc(data_vigencia)
                          .format("DD/MM/YYYY") +
                        "."
                      : "Nenhuma data."
                  }`}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineConnector sx={{ bgcolor: "secondary.main" }} />
                  <TimelineDot
                    color={data_vigencia ? "info" : "grey"}
                  >
                    <AccessTimeFilledIcon />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: "12px", px: 2 }}>
                  <Typography variant="h6" component="span">
                    Data de vigência
                  </Typography>
                </TimelineContent>
              </TimelineItem>

              <TimelineItem>
                <TimelineOppositeContent
                  sx={{ m: "auto 0" }}
                  variant="body2"
                  color="text.secondary"
                >
                  {data_prorrogacao
                    ? "Prorrogado em " + moment.utc(data_prorrogacao).format("DD/MM/YYYY") + "."
                    : "Sem prorrogação registrada."}
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineConnector />
                  <TimelineDot color={data_prorrogacao ? "secondary" : "grey"}>
                    <AutorenewIcon />
                  </TimelineDot>
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent sx={{ py: "12px", px: 2 }}>
                  <Typography variant="h6" component="span">
                    Data de prorrogação
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            </Timeline>
          </Grid>
        </Grid>
      </ListItem>
    </List>
  );
};

export default ProcessDetailsHeader;
